// Dependencies
import nets from 'nets';
import qs from 'query-string';
import _ from 'lodash';

/**
 * Utility for checking NW WP API respnse for not found.
 */
const wpResourceNotFound = (res) => _.get(res, 'body.status') === 404;

/**
 * Utility module for fetching data from the data URL
 */
export function fetchHelper(
  url,
  requestParams = undefined,
  queryParams = {},
  method = 'POST',
  callback = () => {},
  callbackErr = () => {}
) {
  const params = {
    client_id: process.env.CLIENT_ID,
    ...queryParams,
  };

  // Set up the request
  const request = _.assign({
    url: `${url}?${qs.stringify(params)}`,
    method,
    encoding: 'utf8',

    timeout: 100000,
    body: requestParams,
    json: true,
  });

  // Make a request with the given request params
  nets(request, (err, res, body) => {
    if (err || (res && res.statusCode !== 200) || wpResourceNotFound(res)) {
      // Invoke the callback
      callbackErr(err || res.body);
      return;
    }

    // TODO: add data checking to press articles reduction functions and remove this safety.
    // Currently the press route has no checks against unexpected data structure.
    // As is, if this check is removed, and weird data comes back, the app will crash.
    try {
      callback(body);
    } catch (e) {
      callbackErr(e);
    }
  });
}

export default { fetchHelper };
